import { useState, useEffect } from "react";

const useIsAbove1200px = () => {
  const [isAbove1200px, setIsAbove1200px] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      // setIsAbove1200px(window.innerWidth > 1200);
      setIsAbove1200px(window.innerWidth >= 1024);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isAbove1200px;
};

export default useIsAbove1200px;
